export const environmentTypes = {
    actions: {
        CHANGE_ENVIRONMENT: 'environment/CHANGE_ENVIRONMENT'
    },
    mutations: {
        SET_ENVIRONMENT: 'environment/SET_ENVIRONMENT'
    }
}